const getters = {
    isPC: state => state.application.isPC,
    stage: state => state.application.stage,
    authorityRoute: state => state.application.authorityRoute,
}
export default getters